import { render, staticRenderFns } from "./results-section.vue?vue&type=template&id=fb063dc4"
import script from "./results-section.vue?vue&type=script&lang=js"
export * from "./results-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports